import { render, staticRenderFns } from "./AttachUsers.vue?vue&type=template&id=bf35d5c0&scoped=true"
import script from "./AttachUsers.vue?vue&type=script&lang=js"
export * from "./AttachUsers.vue?vue&type=script&lang=js"
import style0 from "./AttachUsers.vue?vue&type=style&index=0&id=bf35d5c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf35d5c0",
  null
  
)

export default component.exports